<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มโซนเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขโซนเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_stock_zone_list">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addStockZone()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}โซนใหม่</h3>
                    </div>
                    <!-- <v-text-field label="ชื่อโซน" v-model="name" :rules="[v => !!v || 'กรุณากรอกชื่อโซน']" required outlined></v-text-field> -->
                    <v-text-field label="ชื่อโซน" v-model="name" :rules="nameRules" required  outlined></v-text-field>
                    <v-autocomplete label="ผู้รับผิดชอบการเบิกโซน" v-model="responsible" :items="user_responsible" item-text="id" :rules="[v => v.length > 0 || 'กรุณากรอกผู้รับผิดชอบการเบิกโซน']" required outlined multiple>
                        <template v-slot:selection="data">
                            <v-chip color="primary" v-bind="data.attrs" :input-value="data.selected" @click="data.select" close @click:close="removeUserResponsible(data.item)">
                                {{ data.item.name }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            {{ data.item.name }}
                        </template>
                    </v-autocomplete>
                    <v-btn color="#038cc1" class="titlefont_stock_zone_list white--text" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.zone}}</td>
                                <td>
                                    <div class="d-flex">
                                        <div class="mr-1" v-for="(user,index) in dataDetail.item.user" :key="index">
                                            {{ dataDetail.item.user.length - 1 !== index ? user.name+',' : user.name }}
                                        </div>
                                    </div>

                                </td>
                                <td>

                                    <span class="edit_data_stock_zone_list" @click="detailStockZone(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import stockzone from '@/api/stock/stocksetting/stockzone.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            alert_show_add: false,
            alert_show_edit: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'ชื่อ',
                    value: 'zone'
                },
                {
                    text: 'ผู้รับผิดชอบ',
                    value: 'user'
                },
                {
                    text: 'แก้ไข',
                    value: 'action'
                },
            ],
            data: [],
            user_responsible: [],
            edit_id: null,
            name: null,
            nameRules: [
      v => !!v.trim() || 'กรุณากรอกชื่อโซน', // ตรวจสอบว่าฟิลด์ไม่ว่างเปล่าและไม่มีแต่ช่องว่าง
      v => v.trim().length >= 3 || 'ชื่อโซนต้องมีอย่างน้อย 3 ตัวอักษร', // ตรวจสอบความยาวขั้นต่ำ 3 ตัวอักษรหลังจากตัดช่องว่างออก
    ],
            responsible: [],
        }
    },
    methods: {
        async removeUserResponsible(item) {
            const index = this.responsible.indexOf(item.id)
            if (index >= 0) this.responsible.splice(index, 1)
        },
        async stockZoneList() {
            this.loading_page = true
            this.data = []
            this.user_responsible = []
            await stockzone.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.zone
                    response.data.zone.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockzone.userList().then((response) => {
                if (response.data.successful === true) {
                    this.user_responsible = response.data.user_list

                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            this.loading_page = false

        },
        async detailStockZone(id) {
            stockzone.detailZone(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.zone.id
                    this.name = response.data.zone.zonename
                    this.responsible = response.data.zone.userzone.map(detail => {
                        return detail.users_id
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addStockZone() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                const data = {
                    outzone_name: this.name,
                    outzone_users: this.responsible,
                }
                if (!this.edit_id) {
                    stockzone.addZone(data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.responsible = []
                            this.stockZoneList()
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.edit_id) {
                    stockzone.editZone(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.responsible = []
                            this.stockZoneList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }

            }
        }
    },
    mounted() {
        this.stockZoneList()
    }
}
</script>

<style scoped>
.card_stock_zone_list>div:first-child {
    width: 30%;

}

.card_stock_zone_list>div:last-child {
    width: 70%;
}

.titlefont_stock_zone_list {
    font-size: 22px !important;
}

.edit_data_stock_zone_list {
    cursor: pointer;
}
</style>
